import { Injectable } from '@angular/core';
import { Headers, Response, Http } from '@angular/http';

import { environment } from '../../environments/environment';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ApiService {
  protected apiUrl = environment.apiUrl;
  protected endpointUrl: string;
  protected headers = new Headers();
  protected authHeaders = new Headers({ Accept: 'application/json', 'Content-Type': 'application/json' });

  constructor(endpointUrl: string, private http_module: Http) {
    this.endpointUrl = endpointUrl;
    this.authHeaders = new Headers({ Accept: 'application/json', 'Content-Type': 'application/json' });
  }

  protected getHeaders(content_type = true) {
    const xAssociation = localStorage.getItem('x-association') || 0;
    this.headers = new Headers({ Accept: 'application/json' });

    if (content_type) {
      this.headers.append('Content-type', 'application/json');
    }

    if (this.getToken()) {
      this.headers.append('Authorization', 'Token ' + this.getToken());
    }

    if (xAssociation) {
      this.headers.append('X-association', `${xAssociation}`);
    }

    this.headers.append('X-platform', 'deopesca');

    return this.headers;
  }

  protected getToken() {
    const user = JSON.parse(localStorage.getItem('currentUser'));
    return user && user.token;
  }

  protected handleError(error: Response | any) {
    let errMsg: string;
    let errObject: {};
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;

      errObject = {
        status: error.status,
        statusText: error.statusText,
        body: body,
        message: errMsg,
      };
    } else {
      errMsg = error.message ? error.message : error.toString();

      errObject = {
        status: '',
        statusText: '',
        body: '',
        message: errMsg,
      };
    }

    return Observable.throw(errObject);
  }

  protected extractData(res: Response) {
    const body = res.json();
    return body || {};
  }

  public list(page, pageSize, filterParams, orderParam): Observable<any> {
    let params = '?page=' + page + '&page_size=' + pageSize;

    if (filterParams !== '') {
      params = params + '&' + filterParams;
    }

    if (orderParam !== '') {
      params = params + '&o=' + orderParam;
    }

    return this.http_module
      .get(this.apiUrl + this.endpointUrl + params, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  public rawList(): Observable<any> {
    return this.http_module
      .get(this.apiUrl + this.endpointUrl, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  public get(id: number): Observable<any> {
    const url = this.apiUrl + this.endpointUrl + id + '/';
    return this.http_module.get(url, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  public create(object: Object): Observable<Object> {
    return this.http_module
      .post(this.apiUrl + this.endpointUrl, JSON.stringify(object), { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  public update(object: Object): Observable<Object> {
    const url = this.apiUrl + this.endpointUrl + object['id'] + '/';
    return this.http_module.put(url, JSON.stringify(object), { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  public delete(id: number): Observable<void> {
    const url = this.apiUrl + this.endpointUrl + id + '/';
    return this.http_module.delete(url, { headers: this.getHeaders() }).catch(this.handleError);
  }

  public getOptions(segment: string = ''): Observable<any> {
    const url = this.apiUrl + this.endpointUrl + segment;
    return this.http_module.options(url, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  public exportToExcel(): Observable<any> {
    return this.http_module
      .post(this.apiUrl + this.endpointUrl + 'download_token/', {}, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  public downloadExcel(token, filterParams, orderParam) {
    const xAssociation = localStorage.getItem('x-association') || 0;
    let params = '';
    if (filterParams !== '') {
      params = params + '&' + filterParams;
    }

    if (orderParam !== '') {
      params = params + '&o=' + orderParam;
    }

    location.assign(this.apiUrl + this.endpointUrl + `download/?token=${token}&x-association=${xAssociation}${params}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/api.service.ts